/* The 2026 redesign lives in pages/presentation. `Home` is the route name
 * mounted at `/` in App.js, so we just re-export the redesigned page under
 * the existing name. The old components in pages/Home/components/* are now
 * orphaned and can be deleted in a cleanup pass. */
import Presentation from "pages/presentation";

export const Home = Presentation;
